import LeafletMap from './leaflet'

class DetailMap extends LeafletMap {
  constructor(el) {
    super()
    this.el = el
    this.initialize()
  }
}

export default DetailMap
